import React from 'react';

/**
 * Footer Component
 * Displays demo badge and copyright information
 */
export default function Footer() {
    return (
        <footer className="app-footer">
            <div className="footer-content">
                <div className="demo-badge">
                    <span>نسخة تجريبية - Demo</span>
                </div>
                <p className="footer-copyright">© م.مشاري دعجم</p>
            </div>
        </footer>
    );
}
